// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// 🔹 Layout
import DashboardLayout from "./layouts/DashboardLayout";

// 🔹 Pages / Sections
import HymnList from "./HymnList";
import HymnDisplay from "./HymnDisplay";
import AuthorList from "./AuthorList";
import KeyList from "./KeyList";
import AppInfoDynamic from "./AppInfoDynamic";
import AppSettings from "./AppSettings";
import Login from "./Login";

// 🔹 Forms (Modular)
import AddHymnForm from "./forms/AddHymnForm";
import EditHymnForm from "./forms/EditHymnForm";

// ✅ App entry point
export default function App() {
  return (
    <Router>
      {/* Toast notifications */}
      <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />

      <Routes>
        {/* 🔓 Public login route */}
        <Route path="/login" element={<Login />} />

        {/* 🏠 Dashboard routes */}
        <Route
          path="/"
          element={
            <DashboardLayout>
              <HymnList />
            </DashboardLayout>
          }
        />

        {/* ➕ Add Hymn */}
        <Route
          path="/add"
          element={
            <DashboardLayout>
              <AddHymnForm />
            </DashboardLayout>
          }
        />

        {/* ✏️ Edit Hymn */}
        <Route
          path="/edit/:hymnId"
          element={
            <DashboardLayout>
              <EditHymnForm />
            </DashboardLayout>
          }
        />

        {/* 🧑‍💼 Authors */}
        <Route
          path="/authors"
          element={
            <DashboardLayout>
              <AuthorList />
            </DashboardLayout>
          }
        />

        {/* 🎵 Keys */}
        <Route
          path="/keys"
          element={
            <DashboardLayout>
              <KeyList />
            </DashboardLayout>
          }
        />

        {/* 📘 About / Dynamic Info */}
        <Route
          path="/about"
          element={
            <DashboardLayout>
              <AppInfoDynamic />
            </DashboardLayout>
          }
        />

        {/* ⚙️ App Settings (theme heading, etc.) */}
        <Route
          path="/settings"
          element={
            <DashboardLayout>
              <AppSettings />
            </DashboardLayout>
          }
        />

        {/* 🎤 Hymn View / Projector */}
        <Route
          path="/view/:hymnId"
          element={
            <DashboardLayout>
              <HymnDisplay />
            </DashboardLayout>
          }
        />
      </Routes>
    </Router>
  );
}
